var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNews = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Modern-Tv-News--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Modern Tv News Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0h-21A1.5 1.5 0 0 0 0 1.5v16A1.5 1.5 0 0 0 1.5 19h21a1.5 1.5 0 0 0 1.5 -1.5v-16A1.5 1.5 0 0 0 22.5 0ZM22 14.5a0.5 0.5 0 0 1 -0.5 0.5h-19a0.5 0.5 0 0 1 -0.5 -0.5v-12a0.5 0.5 0 0 1 0.5 -0.5h19a0.5 0.5 0 0 1 0.5 0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.35 20.68a0.51 0.51 0 0 0 -0.35 -0.18h-4a0.51 0.51 0 0 0 -0.38 0.18l-2.1 2.53A0.5 0.5 0 0 0 8 24h8a0.5 0.5 0 0 0 0.41 -0.79Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 1 0 -5 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10a4 4 0 0 0 -4 3.73 0.23 0.23 0 0 0 0.07 0.19 0.23 0.23 0 0 0 0.18 0.08h7.48a0.23 0.23 0 0 0 0.18 -0.08 0.23 0.23 0 0 0 0.07 -0.19A4 4 0 0 0 8 10Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4h6s0.5 0 0.5 0.5v4s0 0.5 -0.5 0.5h-6s-0.5 0 -0.5 -0.5v-4s0 -0.5 0.5 -0.5",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNews);
export default ForwardRef;